import { render, staticRenderFns } from "./InclusaoOcorrenciaFilterBar.vue?vue&type=template&id=0b027546"
import script from "./InclusaoOcorrenciaFilterBar.vue?vue&type=script&lang=js"
export * from "./InclusaoOcorrenciaFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports